export default __webpack_public_path__ + "static/media/screen5.de3d4f44.png";